import React from 'react';
import { FsProps, FieldSelectDB } from 'motion-components';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { IdocWasteOriginTypes, IdocWasteDestinationTypes } from 'shared-pages/shared/constants';

const gqlGetRec = gql`
  query getCntContributors($where: String, $offset: Int, $limit: Int, $order: String) {
    getCntContributors(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        description: name
        isActive
      }
      recordCount
    }
  }
`;

// export function useGetCompanyTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanyTypesQuery, GetCompanyTypesQueryVariables>) {
//   return ApolloReactHooks.useLazyQuery<GetCompanyTypesQuery, GetCompanyTypesQueryVariables>(GetCompanyTypesDocument, baseOptions);
// }

function useGetRecLazyQuery() {
  return useLazyQuery(gqlGetRec, { fetchPolicy: 'no-cache' });
  //return [null, { loading: null, data: null }];
}

interface Props extends FsProps {
  onlyRecyclers?: boolean;
  onlySecondaryStorage?: boolean;
  collectorId?: number;
}

export const FieldSelectContributor = ({
  label = 'Υπόχρεος',
  name = 'contributorId',
  defaultValues = {},
  onlyRecyclers = false,
  onlySecondaryStorage = false,
  collectorId = null,
  required = false,
  ...rest
}: Props) => {
  const where = () => {
    let where = null;
    if (onlyRecyclers) where = { wastedestinationtypeId: IdocWasteDestinationTypes.Recycling };
    else if (onlySecondaryStorage)
      where = { wastedestinationtypeId: IdocWasteDestinationTypes.SecondaryStorage };

    if (collectorId) {
      where = { ...where, collectorId };
    }
    return where ? JSON.stringify(where) : null;
  };
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      // @ts-ignore
      sbLabel={defaultValues?.collector?.name ?? undefined}
      hook={useGetRecLazyQuery}
      where={where()}
      required={required}
    />
  );
};
